import React from 'react';
import { BaseButton, Icon } from '@common/components';
import { Tooltip } from 'antd';

export const RedoActionButton = ({
  tooltipTitle,
  onRedoAction,
}: {
  tooltipTitle: string;
  onRedoAction: () => void;
}) => (
  <Tooltip title={tooltipTitle}>
    <BaseButton onClick={onRedoAction} shape="circle" type="link">
      <div style={{ marginTop: 3 }}>
        <Icon icon="undo" />
      </div>
    </BaseButton>
  </Tooltip>
);
